/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'caution': {
    width: 16,
    height: 16,
    viewBox: '0 0 40 40',
    data: '<path pid="0" d="M20.143 33.711a2.046 2.046 0 100-4.091 2.046 2.046 0 000 4.091zM21.588 11.524H18.66v16.367h2.928V11.524z" _fill="#1F222C"/><path pid="1" d="M40 36.957H0L20.141 3.2 40 36.957zm-36.79-1.8h33.58L20.141 6.798 3.21 35.158z" _fill="#1F222C"/>'
  }
})
